import { render, staticRenderFns } from "./Custom2.vue?vue&type=template&id=5ce0f351&"
import script from "./Custom2.vue?vue&type=script&lang=js&"
export * from "./Custom2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports